import React from "react";
import BatteryChart from "../BatteryChart";
import BatteryChartSingle from "../BatteryChartSingle";
import { checkTranslation } from "../../utils/useful";

class ProgressChart extends React.Component {
    state = {
        data: [
            {
                color: '#ee5050',
                width: '50',
                percent: '50%',
                dce: 'lorme test'
            },
            {
                color: '#ffa800',
                width: '10',
                percent: '10%',
                dce: 'lorme test'
            },
            {
                color: 'rgb(98, 213, 76)',
                width: '25',
                percent: '25%',
                dce: 'lorme test'
            },
        ],
        data1: [
            {
                color: '#00A4bb',
                width: '50',
                percent: '$2,600.000',
                dce: 'lorme test'
            },
            {
                color: '#ffa800',
                width: '50',
                percent: '$2,600.000',
                dce: 'lorme test'
            },
        ],
        data2: [
            {
                color: 'rgb(98, 213, 76)',
                width: '50',
                percent: '$50',
                dce: 'lorme test'
            },
            // {
            //     color: '#ffa800',
            //     width: '50',
            //     percent: '$50',
            //     dce: 'lorme test'
            // },
        ]
    }
    render() {
        return (
            <>
                {/* {this.props.modal == null && (


                    <div className="dashboard-widgets">
                        <div style={{ borderBottom: '1px solid #ebeaf2' }} className="d-flex justify-content-between p-3">
                            <div>
                                <p>{checkTranslation(this.props.data?.title)}</p>
                            </div>
                            <div>
                                <p>New</p>
                            </div>
                        </div>
                        <div className="p-3" style={{ padding: '0 5%', background: '#fff' }}>
                            <div className="d-flex">
                                <p style={{ fontSize: 12, color: '#777' }}>{this.props.subtitel}</p>
                                <p style={{ fontSize: 12, color: '#777' }}>&nbsp; $2,600.000</p>
                            </div>
                            <div style={{ background: '#ee5050', width: '100%', height: '13px' }}>
                                <div style={{ background: '#00A4bb', width: '50%', height: '13px' }}>

                                </div>

                            </div>
                        </div>
                        <div style={{ borderTop: '1px solid #ebeaf2' }} className="d-flex justify-content-between p-2">
                            <button className="w-100">
                                <p>Current</p>
                                <p>$0.00</p>
                            </button>
                            <div style={{ borderRight: '1px solid #ebeaf2' }} />
                            <button className="w-100">
                                <p>Overdue</p>
                                <p>$2,600.000</p>
                            </button>
                        </div>
                    </div>
                )} */}
                {(this.props.modal == 'lop' || !this.props.modal  ) && (


                    <div className="dashboard-widgets">
                        <div className="d-flex p-3">
                            <div className="text-semibold">
                                <p>{checkTranslation(this.props.data?.title)}</p>
                            </div>
                        </div>
                        <div className="" style={{ padding: '10px 5%', background: '#fff', }}>
                            <div style={{ display: 'flex', background: '#fff', padding: '0 6px 2% 6px' }}>

                                <p style={{ fontSize: 14, fontWeight: '600' }}>$&nbsp;{this.props.praise}&nbsp;Urpaid </p>
                                <p style={{ fontSize: 14 }}>&nbsp;Last 365 days</p>
                            </div>
                            <div className="mb-2 mt-1">
                                {/* <div className="flexcb w-100 px-2">
                                    <div className="" >
                                        <p style={{ fontSize: 16, color: '#ffa800' }}> $2,600.000</p>
                                        <p style={{ fontSize: 13, color: '#777' }}>test</p>
                                    </div>
                                    <div>
                                        <p style={{ fontSize: 16, color: '#00A4bb' }}> $2,600.000</p>
                                        <p style={{ fontSize: 13, color: '#777' }}>test</p>
                                    </div>
                                </div> */}
                                <BatteryChart data={this.state.data1} height={20} borderRadius={5} colortext={true} indicetor={true} />

                            </div>
                            <div className="mt-3">
                                <div style={{ display: 'flex', background: '#fff', padding: '0 6px 2% 6px' }}>

                                    <p style={{ fontSize: 14, fontWeight: '600' }}>$&nbsp;{this.props.praise}&nbsp;Urpaid </p>
                                    <p style={{ fontSize: 14 }}>&nbsp;Last 30 days</p>
                                </div>

                                {/* <div style={{ background: '#fff', padding: '0 6px 2% 6px' }}>

                                    <p style={{}}>$&nbsp;{this.props.praise}&nbsp;Urpaid Last 30 days</p>
                                </div> */}
                                {/* <div className="flexcb w-100 px-2">
                                    <div >
                                        <p style={{ fontSize: 16, color: '#595959' }}> $2,600.000</p>
                                        <p style={{ fontSize: 13, color: '#777' }}>test</p>
                                    </div>
                                    <div>
                                        <p style={{ fontSize: 16, color: '#595959' }}> $2,600.000</p>
                                        <p style={{ fontSize: 13, color: '#777' }}>test</p>
                                    </div>
                                </div> */}
                                <BatteryChart data={this.state.data2} height={20} borderRadius={5} colortext={true} indicetor={true} />

                            </div>
                        </div>

                    </div>
                )}

                {(this.props.modal == 'test' ) && (


                    <div className="dashboard-widgets">
                        <div className="d-flex p-3">
                            <div>
                                <p>{checkTranslation(this.props.data?.title)}</p>
                            </div>
                        </div>
                        <div className="" style={{ padding: '10px 5%', background: '#fff', }}>
                            {/* <div style={{ background: '#fff', padding: '0 6px 2% 6px' }}>

                                <p style={{}}>${this.props.praise}&nbsp;Urpaid Last 365 days</p>
                            </div> */}
                            <div className="mb-2">
                                <div className=" pld-1 ">
                                    <div className=" mb-1 ">
                                        <p style={{ fontSize: 10, color: '#777' }}>Urpaid Last 365 days</p>
                                    </div>
                                </div>
                                {/* <div style={{ overflow: 'hidden', borderRadius: 9, display: 'flex', background: '#eee', width: '100%', height: '30px' }}>
                                    {this.state.data.map((item) => {
                                        return (

                                            <div className="flexcc" style={{ background: `${item.color}`, width: `${item.width}%`, height: '30px' }}>
                                                {/* <div className="flexcc">
                                                    <p style={{ color: "#252525" }}>
                                                        {item.percent}
                                                    </p>
                                                </div> *
                                            </div>
                                        )
                                    })}

                                </div>
                                <div className="flexc mld-2 mt-1">
                                    {this.state.data.map((item) => {
                                        return (
                                            <div className="d-flex">
                                                <div className=" mx-2 mt-1">
                                                    <div className="mrd-1" style={{ background: `${item.color}`, width: '11px', height: '11px', borderRadius: '100px', }} />
                                                </div>
                                                <div className="">
                                                    <p className="mld-1" style={{ fontSize: 12 }}>{item.dce}</p>
                                                    <p style={{ fontWeight: 600 }}>{item.percent}%</p>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div> */}
                                <BatteryChart data={this.state.data} height={20} borderRadius={5} colortext={true} indicetor={true} />
                            </div>

                        </div>

                    </div>
                )}
                {(this.props.modal == 'singl' ) && (


                    <div className="dashboard-widgets">
                        <div className="d-flex p-3">
                            <div>
                                <p>{checkTranslation(this.props.data?.title)}</p>
                            </div>
                        </div>
                        <div className="" style={{ padding: '10px 5%', background: '#fff', }}>
                            {/* <div style={{ background: '#fff', padding: '0 6px 2% 6px' }}>

                                <p style={{}}>${this.props.praise}&nbsp;Urpaid Last 365 days</p>
                            </div> */}
                            <div className="mb-2">
                                <div className=" pld-1 ">
                                    <div className=" mb-1 ">
                                        <p style={{ fontSize: 10, color: '#777' }}>Urpaid Last 365 days</p>
                                    </div>
                                </div>
                                {/* <div style={{ overflow: 'hidden', borderRadius: 9, display: 'flex', background: '#eee', width: '100%', height: '30px' }}>
                                    {this.state.data.map((item) => {
                                        return (

                                            <div className="flexcc" style={{ background: `${item.color}`, width: `${item.width}%`, height: '30px' }}>
                                                {/* <div className="flexcc">
                                                    <p style={{ color: "#252525" }}>
                                                        {item.percent}
                                                    </p>
                                                </div> *
                                            </div>
                                        )
                                    })}

                                </div> */}

                                <>
                                    {/* <div className="d-flex">
                                                <div className=" mx-2 mt-1">
                                                    <div className="mrd-1" style={{ background: `${item.color}`, width: '11px', height: '11px', borderRadius: '100px', }} />
                                                </div>
                                                <div className="">
                                                    <p className="mld-1" style={{ fontSize: 12 }}>{item.dce}</p>
                                                    <p style={{ fontWeight: 600 }}>{item.percent}%</p>
                                                </div>
                                            </div> */}
                                    <BatteryChartSingle data={this.state.data} height={20} borderRadius={5} colortext={true} indicetor={true} />
                                </>

                            </div>

                        </div>

                    </div>
                )}
            </>
        )
    }
}


export default ProgressChart;